import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const CaseStatusAndCategoriesPanelContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export const SubmissionRouteRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SubmissionRouteLabel = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;

export const SubmissionRouteValue = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;
